<img
  [class]="('icon ' + (iconColor ?? '') + ' ' + (customStyleClass() ?? '')).trim()"
  [src]="iconSrc"
  [alt]="icon()"
  [width]="iconSize"
  [height]="iconSize" />
